<template>
  <!-- 账户管理---个人信息 -->
  <div class="page">
    <blue-title>账号信息</blue-title>
    <!-- 账号信息 -->
    <Account></Account>
    <blue-title>权限信息</blue-title>
    <!-- 权限信息 -->
    <Limit></Limit>
  </div>
</template>

<script>
import Account from '@account/components/personal/account';
import Limit from '@account/components/personal/limit';
import { openDialog } from '@account/static/mixin.js';
export default {
  name: 'account',
  components: {
    Account,
    Limit,
  },
  mixins: [openDialog],
  provide() {
    return {
      edit: this.editAccount,
    };
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.page {
  height: 100%;
  background: @bg-white;
  padding-top: 20px;
}
</style>
